// extracted by mini-css-extract-plugin
export default {"recordedGroups":"RecordedGroups_recordedGroups__J+gxF","flexContainer":"RecordedGroups_flexContainer__dKKOZ","flexItemRight":"RecordedGroups_flexItemRight__canKq"};